import createAction from 'redux-actions/es/createAction';

import { FETCH_KKM } from './consts/types';

export { findKkmById } from '@esentai/core/features/kkms/actions';

export const fetchKkm = createAction(FETCH_KKM);
